'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

cbEmail.$inject = ['ValidationService'];


var _module = _angular2.default.module('cb.Email', []);

_module.directive('cbEmail', cbEmail);

exports.default = _module;

/**
 * cb-email
 *
 * Validate e-mail address including top level domain.
 */

/**
* Email PAREL rules:
* - Een emailadres bestaat uit een gebruikersnaam, gevolgd door een '@', gevolgd door een providernaam,
*   gevolgd door een '.', gevolgd door een TLD (top level domain)
* - Gebruikersnaam mag letters, cijfers, verbindingsstreepjes, underscores en punten bevatten. Lengte minimaal 2
* - Provider mag letters, cijfers, verbindingsstreepjes, underscores en punten bevatten. Lengte minimaal 2
* - Top level domain mag enkel letters bevatten en moet een lengte van minimaal twee en maximaal 6 karakters hebben
*/

function cbEmail(ValidationService) {
    return {
        restrict: 'A',
        require: 'ngModel',
        link: function link(scope, element, attrs, ngModel) {
            function validator(value) {
                if (ngModel.$isEmpty(value)) {
                    return true;
                }

                if (attrs.cbEmailParel === 'true') {
                    return ValidationService.validateEmail(value) && ValidationService.validateParelEmail(value);
                }

                return ValidationService.validateEmail(value);
            }

            ngModel.$validators['email'] = validator;
        }
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/lib/core/forms/email/cb-email.directive.js
// module id = 779
// module chunks = 0